import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22cf48c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kho-list-table-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DanhSachKhoTable = _resolveComponent("DanhSachKhoTable")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createBlock(_component_PageContentBase, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_DanhSachKhoTable, {
          items: _ctx.filteredItems,
          "show-delete-kho-button": true,
          "show-edit-button": true,
          onOnDeleteKho: _ctx.fetchData
        }, null, 8, ["items", "onOnDeleteKho"])
      ])
    ]),
    _: 1
  }))
}